import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { RentalObjectImprovement } from '../../model/rental-object-improvement';
import { getMonthName } from '../../../core/helper/month';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Money } from '../../../core/model/money';

@Component({
    selector: 'app-rental-object-improvements-form',
    templateUrl: './rental-object-improvements-form.component.html',
    styleUrls: ['./rental-object-improvements-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectImprovemntsFormComponent implements OnDestroy, OnInit {
  constructor(
    private _fb: FormBuilder,
    private _cf: FormControlExFactory
  ) {}

  @Input() row: RentalObjectImprovement;
  @Input() currencyCode: string;
  @Output() completed = new EventEmitter<boolean>();

  private _subscription: Subscription = new Subscription();
  form: FormGroup;
  yearMask: RegExp = /^\d{1,4}/;
  monthMask: RegExp = /^\d{1,2}/;

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }

  ngOnInit() {
    var zero = new Money(this.currencyCode, 0);
    this.form = this._fb.group({
      performYear: this._cf.createMandatory('RENTAL_OBJECT_IMPROVEMENTS.PERFORM_YEAR', this.row.performYear),
      performMonth: this._cf.create('RENTAL_OBJECT_IMPROVEMENTS.PERFORM_MONTH', this.row.performMonth),
      interval: this._cf.create('RENTAL_OBJECT_IMPROVEMENTS.INTERVAL', this.row.interval),
      stopYear: this._cf.create('RENTAL_OBJECT_IMPROVEMENTS.STOP_YEAR', this.row.stopYear),
      description: this._cf.createMandatory('RENTAL_OBJECT_IMPROVEMENTS.DESCRIPTION', this.row.description),
      cost: this._cf.createWithOptions('RENTAL_OBJECT_IMPROVEMENTS.COST', this.row.cost ? this.row.cost : zero, { required: true }),
      valueRaisingAction: this._cf.create('RENTAL_OBJECT_IMPROVEMENTS.VALUE_RAISING_ACTION', this.row.valueRaisingAction),
    });
  }

  months = [
    { name: getMonthName(1), value: 1 },
    { name: getMonthName(2), value: 2 },
    { name: getMonthName(3), value: 3 },
    { name: getMonthName(4), value: 4 },
    { name: getMonthName(5), value: 5 },
    { name: getMonthName(6), value: 6 },
    { name: getMonthName(7), value: 7 },
    { name: getMonthName(8), value: 8 },
    { name: getMonthName(9), value: 9 },
    { name: getMonthName(10), value: 10 },
    { name: getMonthName(11), value: 11 },
    { name: getMonthName(12), value: 12 },
  ];

  cancel() {
    this.completed.emit(false);
  }

  onSubmit() {
    if (this.form.invalid) return;

    if (this.form.pristine) {
      this.completed.emit(false);
    } else {
      Object.assign(this.row, this.form.value);
      this.completed.emit(true);
    }
  }
}
